<template>
    <div id="AdministracionNovedades"
    v-if="$store.state.global_esAdmin">
     <AdminMenu />
     <div class="row justify-content-md-center align-items-center">
      <div class="col-md-10">
        <div class="row container_admin">
          <!-- LISTA DE NOVEDADES -->
          <div class="col-6 text-left mt-2">
            <b class="titulo">Novedades</b>
          </div>
          <div class="col-6 d-flex justify-content-end mt-3">
            <button
              v-show="
                $store.state.global_esAdmin
              "
              type="button"
              class="btn boton_guardar1 mr-2"
              @click="$router.push('/administracion/novedad/nueva')"
            >
                <i class="fas fa-plus"></i>Nuevo Novedad
            </button>
          </div>
          <div class="col-12 table mt-3">
            <v-client-table
              class="col-md-12 mt-3"
              :columns="columns"
              :data="datosNovedades"
              :options="options"
            >
              <div slot="opciones" slot-scope="props">
                <center>
                  <button
                    class="btn dropdown-toggle boton_12"
                    data-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <ul class="dropdown-menu b-dropdown-opt" role="menu">
                      <center>
                        <li>
                          <a
                            class="btn btn-block mi_boton"
                            @click="editarNovedades(props.row.id)"
                            ><b>Editar</b> 
                          </a>
                        </li>
                      </center>
                      <center>
                        <li>
                          <a
                            class="btn btn-block mi_boton"
                            @click="eliminarNovedad(props.row.id)"
                            >&nbsp;<b>Eliminar</b></a
                          >
                        </li>
                      </center>
                    </ul>
                  </button>
                </center>
              </div>
            </v-client-table>
          </div>
        </div>
       </div>
      </div>  
    </div>
</template>
<script>
// IMPORTACIÓN DE FIREBASE
import { firebase, auth, db } from "../../../firebase";
// IMPORTACIÓN DE SWEET ALERT
import Swal from "sweetalert2";
import AdminMenu from "@/components/AdminMenu.vue";
import moment from "moment";

export default {
  name: "AdministracionNovedades",
  components: {
    AdminMenu,
  },
  data() {
    return {
      datosNovedades: [],
      columns: ["titulo", "registro", "opciones"],
      options: {
        headings: {
          titulo: "Titulo",
          registro: "Registro",
          opciones: "Opciones",
        },
        sortable: ["titulo", "registro", "opciones"],
        texts: {
          filter: "Buscar",
          filterPlaceholder: "",
        },
      },
    };
  },
  created() {
    if(this.$store.state.global_esAdmin){
        this.tablaNovedades();
    }
  },
  methods: {
    // LISTADO DE LAS NOVEDADES
    async tablaNovedades(){
      // console.log('entro');
      this.datosNovedades = [];
      let arrayNovedades = [];
      db.collection("novedades").where("registro.estado", "in", ["Creado", "Editado"]).orderBy("registro.creacion", "asc")
        .onSnapshot((snapshot) => {
          snapshot.docChanges().forEach((change) => {
            arrayNovedades = {
              id: change.doc.id,
              titulo: change.doc.data().titulo,
              registro:  moment(change.doc.data({ serverTimestamps: "estimate" }).registro.creacion.toDate()).format("DD/MM/YYYY hh:mm A")
            }
            if (change.type === "added") {
              this.datosNovedades.unshift(arrayNovedades);
            }
            if (change.type === "modified") {
              for (let index = 0; index < this.datosNovedades.length; index++) {
                if (change.doc.id == this.datosNovedades[index].id) {
                  this.datosNovedades.splice(index, 1, arrayNovedades);
                }
              }
            }
            if (change.type === "removed") {
              for (let index = 0; index < this.datosNovedades.length; index++) {
                if (change.doc.id == this.datosNovedades[index].id) {
                  this.datosNovedades.splice(index, 1);
                }
              }
            }
        });
        let set = new Set(this.datosNovedades.map(JSON.stringify));
        this.datosNovedades = Array.from(set).map(JSON.parse);
        console.log( this.datosNovedades);
      });
    },

    async editarNovedades(id){
      this.$router.push('/administracion/novedad/editar/' + id)
    },

    async eliminarNovedad(id){
      Swal.fire({
        icon: "info",
        background: 'rgba(255, 255, 255)',
        backdrop: `rgba(0,0,0,0.7)`,
        html: "<p class='text-dark'>¿Estás seguro que deseas eliminar esta novedad?</p>",
        showCancelButton: true,
        confirmButtonText: "Eliminar",
        cancelButtonText: "Cancelar",
        confirmButtonColor: "#ee8813",
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          Swal.fire("¡Novedad eliminada correctamente!", "", "success");
          var washingtonRef = db.collection("novedades").doc(id);
          return washingtonRef.update({
            "registro.estado": "Eliminado",
            "registro.actualizacion": firebase.firestore.FieldValue.serverTimestamp()
          })
          .then(() => {
              console.log("Document successfully updated!");
          });
        }
      });
    }

  },
};
</script>